export default "__VITE_ASSET__FDCiPAhP__"